import '@/portal/portal-theme-overrides.scss';
import { Outlet, ScrollRestoration, useLoaderData } from 'react-router-dom';

import LeftSidebar from '@/portal/components/LeftSidebar.tsx';
import TopNavbar from '@/portal/components/TopNavbar.tsx';
import FlashMessage from '@/common/components/FlashMessage.tsx';
import { FlashMessageProvider } from '@/common/contexts/FlashMessageContext.tsx';

import { AuthContext } from '@/portal/contexts/AuthContext';
import type { AuthLoaderData } from '@/portal/types/AuthLoaderData';

function AuthenticatedRoot() {
  const data = useLoaderData() as AuthLoaderData;

  return (
    <AuthContext.Provider value={data}>
      <FlashMessageProvider>
        <div className="portal d-flex flex-column min-vh-100">
          <FlashMessage />
          <TopNavbar />

          <div className="d-flex flex-grow-1">
            <LeftSidebar />
            <main className="flex-grow-1">
              <Outlet />
              <ScrollRestoration />
            </main>
          </div>
        </div>
      </FlashMessageProvider>
    </AuthContext.Provider>
  );
}

export default AuthenticatedRoot;
